import { useEffect, useState } from 'react';
import { fetchProduct } from '@utils/fetch';
import { ProductRedirect } from '@utils/productRedirectUtils';
import { useCartStore } from 'app/(dashboard)/dashboard/(pages)/budgets/stores/userCartStore';
import { useSessionStore } from 'app/stores/globalStore';
import { CartItem, Product, ProductType } from 'app/types/product';
import { useRouter } from 'next/navigation';

export const useAddProductHandler = ({
  isDashboard,
  cleanCart = true,
}: {
  isDashboard: boolean;
  cleanCart?: boolean;
}) => {
  const router = useRouter();

  const { setSelectedTreatments, setSelectedPack, currentOrigin } =
    useSessionStore(state => state);

  const { addItemToCart, removeFromCart, resetCart, cart } = useCartStore(
    state => state
  );

  const [medicalVisitProduct, setMedicalVisitProduct] = useState<Product>();

  useEffect(() => {
    async function initMedicalVisitProduct() {
      const medicalVisit = await fetchProduct(
        process.env.NEXT_PUBLIC_MEDICAL_VISIT || '',
        isDashboard
      );
      setMedicalVisitProduct(medicalVisit);
    }

    initMedicalVisitProduct();
    if (!isDashboard && cleanCart) resetCart();
  }, []);

  const addProductHandler = (product: Product) => {
    const setSelectedTreatment = (product: Product) => {
      setSelectedTreatments([product]);
      ProductRedirect(product, router, cart, currentOrigin);
    };

    if (
      !isDashboard &&
      (!product.isPack ||
        product.title.toLowerCase().includes('polinucleotidos'))
    ) {
      setSelectedTreatment(product);
    } else if (medicalVisitProduct && product.isPack) {
      setSelectedTreatment(medicalVisitProduct);
    }

    if (
      product.isPack &&
      !product.title.toLowerCase().includes('polinucleotidos')
    ) {
      setSelectedPack(product);
    } else {
      setSelectedPack(undefined);
    }

    if (product.type === ProductType.Esthetic) {
      if (cart.length > 0) {
        removeFromCart(
          cart.filter(
            item =>
              item.id === process.env.NEXT_PUBLIC_CITA_PREVIA_ID?.toLowerCase()
          )[0]
        );
      }
      addItemToCart(product as CartItem);
    }
  };

  return addProductHandler;
};
